<template>
  <div class="login-container">
    <div class="login-box">
      <van-loading type="spinner" color="#1989fa" />
      <p class="login-text">登录中...</p>
    </div>
  </div>
</template>

<script>
import { getUrlParam } from '@/utils/utils'
import { Toast } from 'vant'

export default {
  name: 'Login',
  async created() {
    try {
      const code = getUrlParam(window.location.href, 'code')
      
      if (!code) {
        Toast('登录失败，缺少授权码')
        // setTimeout(() => {
        //   this.$router.replace('/')
        // }, 1500)
        return
      }
      
      // 调用登录方法
      await this.$store.dispatch('login/login', code)
      Toast.success('登录成功')
      
      // 获取保存的路径，没有则跳转首页
      const savedPath = localStorage.getItem('user_path') || '/'
      
      // 跳转回用户之前想要访问的页面
      this.$router.replace(savedPath)
    } catch (error) {
      Toast.fail('登录失败，请重试')
      setTimeout(() => {
        this.$router.replace('/')
      }, 1500)
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f7f8fa;
}

.login-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login-text {
  font-size: 16px;
  color: #666;
  margin-top: 20px;
}
</style>
